import { useLingui } from "@lingui/react/macro";
import { Link } from "@tanstack/react-router";
import { ClapperboardIcon } from "lucide-react";

import { SidebarMenuButton, SidebarMenuItem } from "@/shared/ui/sidebar";

import { useHighlightsAllowed } from "../../api/useHighlightsAllowed";

// Пункт «Хайлайты» бокового меню — второй, сразу после главной: клипы — то, ради чего
// возвращаются после матча. Пока только у команды (`useHighlightsAllowed`).
export const HighlightsNavItem = () => {
  const { t } = useLingui();
  if (!useHighlightsAllowed()) {
    return null;
  }
  return (
    <SidebarMenuItem>
      <SidebarMenuButton asChild tooltip={t`Highlights`}>
        <Link to="/highlights">
          <ClapperboardIcon aria-hidden="true" />
          <span>{t`Highlights`}</span>
        </Link>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
};
